import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import "./Immersive.css";
import ImmersiveExp from '../ui/ImmersiveExp.svg'
import InterExh from '../ui/IntEx.svg'
import VirtualStudio from '../ui/vssmall.svg'

const CARDS = [
    {
        title: "Interactive Exhibits",
        img: InterExh,
        index: "01",
        span: "immersive-col-span-12",
    },
    {
        title: "Virtual Studio Solution",
        img: VirtualStudio,
        index: "02",
        span: "immersive-col-span-6",
    },

    {
        title: "Immersive Experiences",
        img: ImmersiveExp,
        index: "03",
        span: "immersive-col-span-6",
    },
];


export const Immersive = () => {

    return (
        <section
            id="immersive"
            data-testid="immersive-section"
            className="immersive-section py-5 py-md-10 border-top"
        >
            <div className="container-db">
                <div className="row g-5 mb-5">
                    <div className="col-12 col-lg-5">
                        <div className="position-sticky" style={{ top: "8rem" }}>
                            <div className="font-mono-tech text-xs uppercase tracking-[0.2em] immersive-eyebrow mb-4 fade-in-up fs-5">
                                ⟶ Immersive Practice
                            </div>
                            <h2 className="font-heading immersive-title text-4xl text-md-6xl mb-4">
                                Tech +
                                <br />
                                Creativity
                                <br />
                                <span className="text-primary-custom">Transformed</span>
                            </h2>
                            <p className="hero-subtitle m-0 mb-5" data-testid="hero-subtitle">
                                Every project begins with an idea and comes to life through engineering, creativity, and innovation. We combine cutting-edge technologies to create immersive experiences that inspire, engage, and leave a lasting impression.
                            </p>
                            <Link
                                to="/services"
                                data-testid="immersive-explore-cta"
                                className="inline-flex align-items-center gap-2 font-mono-tech text-xs uppercase tracking-wide-18 immersive-link pb-1 fs-5"
                            >
                                Explore Our Work <ArrowUpRight style={{ width: '16px', height: '16px' }} />
                            </Link>
                        </div>
                    </div>

                    <div className="col-12 col-lg-7">
                        <div className="immersive-grid">
                            {CARDS.map((c) => (
                                <article
                                    key={c.title}
                                    data-testid={`immersive-card-${c.index}`}
                                    className={`immersive-card ${c.span}`}
                                >
                                    <div
                                        className="immersive-card-bg"
                                        style={{ backgroundImage: `url(${c.img})` }}
                                    />
                                    <div className="immersive-card-overlay" />
                                    <div className="immersive-card-content p-3">
                                        <div className="font-mono-tech immersive-label-top fs-5 fw-bold" style={{ color: '#40e0d0' }}>
                                            {c.title}
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};


export default Immersive;
